import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useButton } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import CheckIcon from '~Assets/icons/check.svg';
import { Box, TransparentButton } from '~Styles';
import { Textfit } from 'react-textfit';

export const ListItemWrapper = styled(TransparentButton)<{ isActive?: boolean }>`
  height: 64px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  text-align: left;
  color: var(--colorBlueGray900);
  letter-spacing: var(--letterSpacing);
  gap: 16px;
  justify-content: space-between;
  opacity: ${({ isActive }) => (isActive ? 0.8 : 1)};

  button {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--colorBlueGray200);
  }
`;

const OfferNameLabel = styled(Textfit)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

const DiscRateLabel = styled.div<{ bg?: string }>`
  background: ${({ bg }) => bg || 'var(--colorUIGreen)'};
  color: var(--colorWhite);
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 14px;
`;

interface Props {
  name: string;
  tagText?: string;
  onClick?: () => void;
  tagColor?: string;
  /** If true, the item is disabled and shows a checkmark */
  isActive?: boolean;
}

const ListItem: FC<Props> = ({
  name,
  tagText,
  onClick,
  tagColor = 'var(--colorUIGreen)',
  isActive = false,
}) => {
  const handleClick = useButton({
    onClick: () => {
      if (onClick) {
        onClick();
      }
    },
  });

  return (
    <ListItemWrapper fluid {...handleClick} isActive={isActive}>
      <OfferNameLabel min={12} max={14}>
        {name}
      </OfferNameLabel>

      <Box display="flex" alignItems="center" gap="xs">
        {tagText && <DiscRateLabel bg={tagColor}>{tagText}</DiscRateLabel>}
        {isActive && (
          <Icon src={CheckIcon} color="var(--colorBlueGray1300)" height="24px" width="24px" />
        )}
      </Box>
    </ListItemWrapper>
  );
};

export default ListItem;
